import React from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import { FaUserGraduate, FaBook, FaHandHoldingUsd } from "react-icons/fa";
import { useInView } from "react-intersection-observer";

const StatsSection = () => {
  const { t } = useTranslation();
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once
    threshold: 0.3, // Trigger when 30% is visible (adjust as needed)
  });

  const stats = [
    {
      id: 1,
      value: 900,
      label: "studentsSupported",
      icon: <FaUserGraduate className="text-4xl mb-2" />,
    },
    {
      id: 2,
      value: 12,
      label: "coursesOffered",
      icon: <FaBook className="text-4xl mb-2" />,
    },
    {
      id: 3,
      value: 38,
      label: "scholarshipsAwarded",
      icon: <FaHandHoldingUsd className="text-4xl mb-2" />,
    },
  ];

  return (
    <section className="py-16 bg-primary-600 text-white" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.id} className="p-6">
              <div className="flex justify-center text-primary-200">
                {stat.icon}
              </div>
              <div className="text-5xl font-bold mb-2">
                <CountUp
                  end={inView ? stat.value : 0}
                  duration={3}
                  start={inView ? undefined : 0}
                />
              </div>
              <div className="text-xl">{t(`stats.${stat.label}`)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
